import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { createIconSetFromFontello } from "react-native-vector-icons";
import QuickAccess from "../../../src/viewModels/QuickAccessViewModel";
import { getScenarioIconByMainCondition } from "../../actions/ScenarioHelper";
import { faQuestionCircle } from "../../../assets/consts/faCharCodes";
import AreaListItem from "../../components/AreaListItem";
import { Keyboard } from "react-native";
import Scenario from "../../viewModels/Scenario";

const KEYS = {
  AREAS_CACHE: "AREAS_CACHE",
  DEVICES_CACHE: "DEVICES_CACHE",
  USER_QUICK_ACCESS_CACHE: "USER_QUICK_ACCESS_CACHE",
  AREA_STATE_QUICK_ACCESS_CACHE: "AREA_STATE_QUICK_ACCESS_CACHE",
  SCENARIO_QUICK_ACCESS_CACHE: "SCENARIO_QUICK_ACCESS_CACHE",
  QUICKACCESS_CACHE: "QUICKACCESS_CACHE",
  BUILDINGS_CACHE: "BUILDINGS_CACHE",
};

class CacheStorage {
  constructor() {
    this.Areas = {
      GetAll: async (buildingId = "") => {
        try {
          var localAreasJson = await AsyncStorage.getItem(KEYS.AREAS_CACHE);
          if (localAreasJson) {
            var localAreas = JSON.parse(localAreasJson);
            if (Array.isArray(localAreas)) {
              if (buildingId) {
                return localAreas.filter((a) => a.buildingId == buildingId);
              }
              return localAreas;
            }
          }
          return [];
        } catch (error) {
          console.log("error on CacheStorage.Areas.GetAll\r\n", error);
          AsyncStorage.removeItem(KEYS.AREAS_CACHE);
          return [];
        }
      },
      SetAll: async (areas) => {
        try {
          if (Array.isArray(areas)) {
            var buildingId = (await SecureStore.getBuildingId()) || "";
            if (buildingId) {
              areas = areas.map((a) => {
                return {
                  ...a,
                  buildingId,
                };
              });
            }
            var oldAreasJson = await AsyncStorage.getItem(KEYS.AREAS_CACHE);
            var oldAreas = JSON.parse(oldAreasJson);
            var areasFromOtherBuildings = [];
            if (oldAreas) {
              oldAreas.filter(
                (a) => a.buildingId && a.buildingId != buildingId
              );
            }
            var areasToStore = [...areasFromOtherBuildings, ...areas];
            AsyncStorage.setItem(
              KEYS.AREAS_CACHE,
              JSON.stringify(areasToStore)
            );
          }
        } catch (error) {
          console.log("error on CacheStorage.Areas.SetAll\r\n", error);
        }
      },
      ClearAll: () => {
        try {
          AsyncStorage.removeItem(KEYS.AREAS_CACHE);
        } catch (error) {
          console.log("error on CacheStorage.Areas.ClearAll\r\n", error);
        }
      },
    };

    this.buildings = {
      GetAll: async () => {
        try {
          var localBuildingsJson = await AsyncStorage.getItem(
            KEYS.BUILDINGS_CACHE
          );
          if (localBuildingsJson) {
            var localBuildings = JSON.parse(localBuildingsJson);
            if (Array.isArray(localBuildings)) {
              return localBuildings;
            }
          }
          return [];
        } catch (error) {
          console.log("error on CacheStorage.Buildings.GetAll\r\n", error);
          AsyncStorage.removeItem(KEYS.BUILDINGS_CACHE);
          return [];
        }
      },
      SetAll: async (buildings) => {
        try {
          if (Array.isArray(buildings)) {
            AsyncStorage.setItem(
              KEYS.BUILDINGS_CACHE,
              JSON.stringify(buildings)
            );
          }
        } catch (error) {
          console.log("error on CacheStorage.Buildings.SetAll\r\n", error);
        }
      },
      ClearAll: () => {
        try {
          AsyncStorage.removeItem(KEYS.BUILDINGS_CACHE);
        } catch (error) {
          console.log("error on CacheStorage.Buildings.ClearAll\r\n", error);
        }
      },
    };

    this.Devices = {
      GetAll: async () => {
        try {
          var localDevicesJson = await AsyncStorage.getItem(KEYS.DEVICES_CACHE);
          if (localDevicesJson) {
            var localDevices = JSON.parse(localDevicesJson);
            if (Array.isArray(localDevices)) return localDevices;
          }
          return [];
        } catch (error) {
          console.log("error on CacheStorage.Devices.GetAll\r\n", error);
          AsyncStorage.removeItem(KEYS.DEVICES_CACHE);
          return [];
        }
      },
      SetAll: (devices) => {
        try {
          AsyncStorage.setItem(KEYS.DEVICES_CACHE, JSON.stringify(devices));
        } catch (error) {
          console.log("error on CacheStorage.Devices.SetAll\r\n", error);
        }
      },
      ClearAll: () => {
        try {
          AsyncStorage.removeItem(KEYS.DEVICES_CACHE);
        } catch (error) {
          console.log("error on CacheStorage.Devices.ClearAll\r\n", error);
        }
      },
    };

    this.QuickAccess = {
      GetAll: async () => {
        var quickAccess = [];
        var userQuickAccess = [];
        var scenarioQuickAccess = [];
        try {
          var areaStateQuickAccessJson = await AsyncStorage.getItem(
            KEYS.AREA_STATE_QUICK_ACCESS_CACHE
          );
          if (areaStateQuickAccessJson) {
            quickAccess = JSON.parse(areaStateQuickAccessJson);
          }
          var scenarioQuickAccessJson = await AsyncStorage.getItem(
            KEYS.SCENARIO_QUICK_ACCESS_CACHE
          );
          if (scenarioQuickAccessJson) {
            scenarioQuickAccess = JSON.parse(scenarioQuickAccessJson);
          }
          var userQuickAccessJson = await AsyncStorage.getItem(
            KEYS.USER_QUICK_ACCESS_CACHE
          );
          if (userQuickAccessJson) {
            userQuickAccess = JSON.parse(userQuickAccessJson);
          }
          if (
            Array.isArray(areaStateQuickAccess) &&
            Array.isArray(scenarioQuickAccess) &&
            Array.isArray(userQuickAccess)
          ) {
            var localStorage = [
              ...areaStateQuickAccess,
              ...scenarioQuickAccess,
              ...userQuickAccess,
            ];
            return localStorage;
          } else {
            return [];
          }
        } catch (error) {
          console.log(
            "error on CacheStorage.QuickAccess.GetAllScenario\r\n",
            error
          );

          AsyncStorage.removeItem(KEYS.USER_QUICK_ACCESS_CACHE);
          AsyncStorage.removeItem(KEYS.AREA_STATE_QUICK_ACCESS_CACHE);
          AsyncStorage.removeItem(KEYS.SCENARIO_QUICK_ACCESS_CACHE);
          return [];
        }
      },
      SetScenarioQuickAccess: async (scenarios = []) => {
        try {
          var scenariosList = [];
          var areasState = [];
          var devicesState = [];
          let icon = faQuestionCircle;
          var buildingId = (await SecureStore.getActiveProfile())?.id || "";
          for (var i in scenarios) {
            var s = scenarios[i];
            var scenarioModel = new Scenario();
            Object.assign(scenarioModel, s);
            let scenarioIcon = getScenarioIconByMainCondition(
              scenarioModel.getMainCondition()
            );
            if (scenarioIcon) {
              icon = scenarioIcon;
            }
            var quickAccess = new QuickAccess(
              s.id,
              s.uId,
              s.name,
              icon,
              "SCENARIO",
              buildingId
            );
            scenariosList.push(quickAccess);
          }
          var quickAccessContentJson = await AsyncStorage.getItem(
            KEYS.QUICKACCESS_CACHE
          );
          if (quickAccessContentJson) {
            var quickAccessContent = JSON.parse(quickAccessContentJson);
            if (Object.keys(quickAccessContent).length != 0) {
              areasState = quickAccessContent["AREAS_QUICK"] || [];
              devicesState = quickAccessContent["DEVICES_QUICK"] || [];

              var allScenarios = quickAccessContent["SCENARIOS"];
              var scenariosFromOtherBuildings = allScenarios.filter(
                (s) => s.buildingId && s.buildingId != buildingId
              );

              scenariosList = [
                ...scenariosFromOtherBuildings,
                ...scenariosList,
              ];
            }
          }
          AsyncStorage.setItem(
            KEYS.QUICKACCESS_CACHE,
            JSON.stringify({
              SCENARIOS: scenariosList,
              AREAS_QUICK: areasState,
              DEVICES_QUICK: devicesState,
            })
          );
        } catch (error) {
          console.log(
            "error on CacheStorage.QuickAccess.setScenarioQuickAccess\r\n".error
          );
        }
      },
      SetUserQuickAccess: async (userQuickAccess = []) => {
        try {
          var userQuickAccessList = [];
          var scenarios = [];
          var areasState = [];
          var buildingId = (await SecureStore.getActiveProfile())?.id || "";
          for (var i in userQuickAccess) {
            var u = userQuickAccess[i];
            var quickAccess = new QuickAccess(
              u.deviceId,
              u.deviceUId,
              u.deviceName,
              u.customIcon,
              u.deviceType,
              buildingId
            );
            userQuickAccessList.push(quickAccess);
          }
          var quickAccessContentJson = await AsyncStorage.getItem(
            KEYS.QUICKACCESS_CACHE
          );
          if (quickAccessContentJson) {
            var quickAccessContent = JSON.parse(quickAccessContentJson);
            if (Object.keys(quickAccessContent).length != 0) {
              areasState = quickAccessContent["AREAS_QUICK"] || [];
              scenarios = quickAccessContent["SCENARIOS"] || [];
              var otherBuildingsDeviceQuickAccess = (
                quickAccessContent["DEVICES_QUICK"] || []
              ).filter((d) => d.buildingId && d.buildingId != buildingId);

              userQuickAccessList = [
                ...userQuickAccessList,
                ...otherBuildingsDeviceQuickAccess,
              ];
            }
          }

          AsyncStorage.setItem(
            KEYS.QUICKACCESS_CACHE,
            JSON.stringify({
              SCENARIOS: scenarios,
              AREAS_QUICK: areasState,
              DEVICES_QUICK: userQuickAccessList,
            })
          );
        } catch (error) {
          console.log(
            "error on CacheStorage.QuickAccess.SetUserQuickAccess\r\n",
            error
          );
        }
      },
      SetAreaStateQuickAccess: async (areaStates = []) => {
        try {
          var areasList = [];
          var devices = [];
          var scenarios = [];
          var buildingId = (await SecureStore.getActiveProfile())?.id || "";
          for (var i in areaStates) {
            var a = areaStates[i];
            var quickAccess = new QuickAccess(
              a.id,
              a.uId,
              a.name,
              a.activeIcon,
              "AREAS_QUICK",
              buildingId
            );
            areasList.push(quickAccess);
          }
          var quickAccessContentJson = await AsyncStorage.getItem(
            KEYS.QUICKACCESS_CACHE
          );
          if (quickAccessContentJson) {
            var quickAccessContent = JSON.parse(quickAccessContentJson);
            if (Object.keys(quickAccessContent).length != 0) {
              devices = quickAccessContent["DEVICES_QUICK"] || [];
              scenarios = quickAccessContent["SCENARIOS"] || [];
              var areaStatesFromOtherBuildings = (
                quickAccessContent["AREAS_QUICK"] || []
              ).filter((a) => a.buildingId && a.buildingId != buildingId);
              areasList = [...areasList, ...areaStatesFromOtherBuildings];
            }
          }
          AsyncStorage.setItem(
            KEYS.QUICKACCESS_CACHE,
            JSON.stringify({
              SCENARIOS: scenarios,
              AREAS_QUICK: areasList,
              DEVICES_QUICK: devices,
            })
          );
        } catch (error) {
          console.log(
            "error on CacheStorage.QuickAccess.setAreaStateQuickAccess",
            error
          );
        }
      },
      GetScenarioQuickAccess: async (buildingId = "") => {
        try {
          var quickAccessContentJson = await AsyncStorage.getItem(
            KEYS.QUICKACCESS_CACHE
          );
          if (quickAccessContentJson) {
            var quickAccessContent = JSON.parse(quickAccessContentJson);
            if (quickAccessContent) {
              if (buildingId) {
                var result = quickAccessContent["SCENARIOS"].filter(
                  (s) => s.buildingId == buildingId
                );
                return result;
              } else {
                return quickAccessContent["SCENARIOS"];
              }
            }
          }
          return [];
        } catch (error) {
          console.log(
            "error on CacheStorage.QuickAccess.GetScenarioQuickAccess\r\n",
            error
          );
          return [];
        }
      },
      GetUserQuickAccess: async (buildingId = "") => {
        try {
          var quickAccessContentJson = await AsyncStorage.getItem(
            KEYS.QUICKACCESS_CACHE
          );
          if (quickAccessContentJson) {
            var quickAccessContent = JSON.parse(quickAccessContentJson);
            if (quickAccessContent) {
              if (buildingId) {
                return quickAccessContent["DEVICES_QUICK"].filter(
                  (d) => d.buildingId == buildingId
                );
              }
              return quickAccessContent["DEVICES_QUICK"];
            }
          }
          return [];
        } catch (error) {
          console.log(
            "error on CatchStorage.QuickAccess.GetUserQuickAccess\r\n",
            error
          );
          return [];
        }
      },
      GetAreaStateQuickAccess: async (buildingId = "") => {
        try {
          var quickAccessContentJson = await AsyncStorage.getItem(
            KEYS.QUICKACCESS_CACHE
          );
          if (quickAccessContentJson) {
            var quickAccessContent = JSON.parse(quickAccessContentJson);
            if (quickAccessContent) {
              if (buildingId) {
                return quickAccessContent["AREAS_QUICK"].filter(
                  (a) => a.buildingId == buildingId
                );
              }
              return quickAccessContent["AREAS_QUICK"];
            }
          }
          return [];
        } catch (error) {
          console.log(
            "error on CatchStorage.QuickAccess.GetAreaStateQuickAccess\r\n",
            error
          );
          return [];
        }
      },
      ClearAll: () => {
        try {
          AsyncStorage.removeItem(KEYS.USER_QUICK_ACCESS_CACHE);
          AsyncStorage.removeItem(KEYS.AREA_STATE_QUICK_ACCESS_CACHE);
          AsyncStorage.removeItem(KEYS.SCENARIO_QUICK_ACCESS_CACHE);
          AsyncStorage.removeItem(KEYS.QUICKACCESS_CACHE);
        } catch (error) {
          console.log("error on CacheStorage.QuickAccess.ClearAll\r\n", error);
        }
      },
    };
  }
}

export default CacheStorage;
